import { Button } from "./Button";

export type ToastVariant = "success" | "error" | "info" | "warning";

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastItem {
  id: string;
  message: string;
  variant: ToastVariant;
  action?: ToastAction;
}

interface ToastProps {
  toast: ToastItem;
  onClose: (id: string) => void;
}

const variantClasses = {
  success: "border-success bg-success-bg text-success",
  error: "border-danger bg-danger-bg text-danger",
  info: "border-primary bg-primary-bg text-primary",
  warning: "border-warning bg-warning-bg text-warning",
} as const;

export function Toast({ toast, onClose }: ToastProps): JSX.Element {
  return (
    <div
      className={cx(
        "pointer-events-auto flex w-full items-start gap-3 rounded-lg border p-4 shadow-floating",
        variantClasses[toast.variant],
      )}
    >
      <p className="min-w-0 flex-1 text-sm font-medium leading-5">{toast.message}</p>
      {toast.action !== undefined && (
        <Button variant="ghost" size="sm" onClick={toast.action.onClick}>
          {toast.action.label}
        </Button>
      )}
      <button
        type="button"
        aria-label="閉じる"
        onClick={() => onClose(toast.id)}
        className="min-h-0 text-lg leading-none opacity-70 hover:opacity-100"
      >
        ×
      </button>
    </div>
  );
}

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
